import { AcademyPrograms } from "../modules/academyPrograms/ui";

export default function AcademyProgramsPage() {
  return (
      <div className="mt-2">
        <AcademyPrograms />
      </div>
  );
}
